import { Position } from './Position';
import { Scale } from './Scale';
import { Rotation } from './Rotation';
import { ElementPosition } from '../ElementPosition';
export class Transform {
    constructor(
        engine,
        isLocked,
        shouldBeConstrained,
        position = new Position(),
        scale = new Scale(),
        rotation = new Rotation(),
        center = () => {
            return new Position();
        }
    ) {
        this._localPos = undefined;
        this.groupId = undefined;
        this.isMovable = true;
        this._engine = engine;
        this._pos = position;
        this.shouldApplyConstraints = shouldBeConstrained;
        this.applyConstraints();
        this._scale = scale;
        this._rotation = rotation;
        this._isLocked = isLocked;
        this._center = center;
    }
    get isLocked() {
        return this._isLocked;
    }
    set isLocked(isLocked) {
        this._isLocked = isLocked;
    }
    move(movement) {
        if (this.isLocked || !this.isMovable) {
            return;
        }
        this._pos.applyVector(movement);
        this.applyConstraints();
    }
    moveTo(pos, force = false) {
        if ((this.isLocked || !this.isMovable) && !force) {
            return;
        }
        this._pos = pos;
        this.applyConstraints();
    }
    applyConstraints() {
        if (!this.shouldApplyConstraints) {
            return;
        }

        // Vérifier que Engine a un canvas initialisé
        if (!this._engine || !this._engine.widthCanvas || !this._engine.heightCanvas) {
            // Constraints non applicables sans engine - normal pour certains éléments
            return;
        }

        if (this._pos.x < 0) {
            this._pos.x += this._engine.widthCanvas;
        }
        if (this._pos.x > this._engine.widthCanvas) {
            this._pos.x -= this._engine.widthCanvas;
        }
        if (this._pos.y > this._engine.heightCanvas) {
            this._pos.y = this._engine.heightCanvas;
        }
        if (this._pos.y < 0) {
            this._pos.y = 0;
        }
    }
    rotateToward(position, offset, force = false) {
        if ((this.isLocked || !this.isMovable) && !force) {
            return;
        }
        if (Math.abs(position.x) == Infinity || Math.abs(position.y) == Infinity) {
            throw 'Infinity is not a correct value';
        }
        this._rotation.angle = Rotation.getAngle(position, this._center().applyVector(offset));
    }
    resize(scale, force = false) {
        if ((this.isLocked || !this.isMovable) && !force) {
            return;
        }
        if (Math.abs(scale.scaleX) == Infinity || Math.abs(scale.scaleY) == Infinity) {
            throw 'Infinity is not a correct value';
        }
        this._scale = scale;
    }
    get pos() {
        return this.getPosFromLocalPos() || this._pos.clone();
    }
    get localPos() {
        let _a;
        return ((_a = this._localPos) === null || _a === void 0 ? void 0 : _a.clone()) || undefined;
    }
    set localPos(pos) {
        this._localPos = pos;
    }
    get scale() {
        return this._scale.clone();
    }
    get rotation() {
        return this._rotation.clone();
    }
    get angle() {
        return this.rotation.angle;
    }
    rotate(angle, force = false) {
        if ((this.isLocked || !this.isMovable) && !force) {
            return;
        }
        this.angle += angle;
    }
    set angle(angle) {
        if (Math.abs(angle) == Infinity) {
            throw 'Infinity is not a correct value';
        }
        this._rotation.angle = angle;
    }
    getPosFromLocalPos(from = new ElementPosition('center')) {
        if (!this.groupId || !this._localPos) {
            return;
        }
        const group = this._engine.find(this.groupId);
        const newPosX = this._localPos.x * group.size.width + group.getPosition(from.namePosition).x;
        const newPosY = this._localPos.y * group.size.height + group.getPosition(from.namePosition).y;
        return new Position(newPosX, newPosY);
    }
}
